// src/components/MonthsTabs.js (Updated and Future-Proof)

import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import dayjs from "dayjs"; // Import dayjs

// Import the PlanningContainer you want to display in each tab
import PlanningContainer from "./PlanningContainer";

// --- Dynamically generate the next 12 months ---

const generateMonths = (pastMonths = 6, futureMonths = 12) => {
  const monthsArray = [];
  const today = dayjs();

  // Determine the starting point of our loop (e.g., 3 months ago)
  const startDate = today.subtract(pastMonths, "month");

  // The total number of months to generate
  const totalMonths = pastMonths + 1 + futureMonths; // Past + Current + Future

  for (let i = 0; i < totalMonths; i++) {
    const targetMonth = startDate.add(i, "month");
    monthsArray.push({
      label: targetMonth.format("MMMM YYYY"),
      value: targetMonth.startOf("month").format("YYYY-MM-DD"),
    });
  }
  return monthsArray;
};

const pastMonthsToShow = 6;
const futureMonthsToShow = 11; // 11 future + 1 current = 12 months ahead
const dynamicMonths = generateMonths(pastMonthsToShow, futureMonthsToShow);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MonthsTabs() {
  // The first tab (index 0) will always be the current month.
  const [value, setValue] = React.useState(pastMonthsToShow);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="monthly planning tabs"
          variant="scrollable"
          scrollButtons="auto"
        >
          {dynamicMonths.map((month, index) => (
            <Tab key={index} label={month.label} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>

      {/* Use the 'value' from our dynamic array to pass to the container */}
      {dynamicMonths.map((month, index) => (
        <CustomTabPanel key={index} value={value} index={index}>
          {/* Pass the unambiguous 'YYYY-MM-DD' string as the month prop */}
          <PlanningContainer month={month.value} />
        </CustomTabPanel>
      ))}
    </Box>
  );
}
